import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Text, Modal } from '@paypalcorp/pp-react';
import { StyleSheet, css } from '../../utility/paypalAphrodite';
import SocialShareEmail from './socialShareEmail';
import SocialShareMobile from './socialShareMobile';
import SocialShareFacebook from './socialShareFacebook';
import SocialShareMessenger from './socialShareMessenger';
import SocialShareWhatsapp from './socialShareWhatsapp';
import SocialShareTwitter from './socialShareTwitter';
import SocialShareCopyLink from './socialShareCopyLink';
import ShareIllustration from './shareIllustration';
import CopyLink from '../CopyLink';

const styles = StyleSheet.create({
  socialContainer: {
    display: 'flex',
  },
  copyLinkContainer: {
    marginRight: 0,
    marginLeft: 24,
  },
});

export default function SocialShare({
  shareUrl,
  socialCampaign,
  isMobile,
  ...props
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const encodedUrl = encodeURIComponent(shareUrl);
  const appId = '321983581337375';
  const emailUrl = `mailto:?subject=${socialCampaign.emailSubject}&body=${socialCampaign.emailBody}`;
  const facebookUrl = `https://www.facebook.com/dialog/share?app_id=${appId}&display=popup&quote=${socialCampaign.facebookMessage}&href=${encodedUrl}`;
  const fbMessengerUrl = `https://www.facebook.com/dialog/send?app_id=${appId}&display=popup&link=${encodedUrl}&redirect_uri=https://www.paypal.com`;
  const whatsappUrl = `https://${
    isMobile ? 'api' : 'web'
  }.whatsapp.com/send?&text=${socialCampaign.whatsappMessage}%20${encodedUrl}`;
  const twitterUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${socialCampaign.twitterMessage}`;

  function handleSocialLinkClick(url, type) {
    window.open(
      url,
      'popup',
      'toolbar=0,status=0,width=640,height=340,scrollable=true'
    );
    handleAnalytics(`social_share_${type}`);
  }

  function handleOpenCopyModal() {
    setIsModalOpen(true);
  }

  function handleMobileClick() {
    if (navigator.share) {
      navigator.share({
        title: socialCampaign.mobileTitle,
        text: socialCampaign.mobileText,
        url: encodedUrl,
      });
    } else {
      window.open(
        encodedUrl,
        'popup',
        'toolbar=0,status=0,width=640,height=340,scrollable=true'
      );
    }
    handleAnalytics('mobile_share');
  }

  function handleAnalytics(type) {
    if (props.analytics) {
      props.analytics(type);
    }
  }

  return (
    <>
      <div
        className={`${css(styles.socialContainer)} ppvx_justify-content-${
          props.align
        }`}
        data-testid="social-share-container"
      >
        {socialCampaign.email && (
          <SocialShareEmail url={emailUrl} handleAnalytics={handleAnalytics} />
        )}
        {navigator.share && socialCampaign.mobile && (
          <SocialShareMobile handleMobileClick={handleMobileClick} />
        )}
        {socialCampaign.facebook && (
          <SocialShareFacebook
            url={facebookUrl}
            handleSocialLinkClick={handleSocialLinkClick}
          />
        )}
        {socialCampaign.facebookMessenger && (
          <SocialShareMessenger
            url={fbMessengerUrl}
            handleSocialLinkClick={handleSocialLinkClick}
          />
        )}
        {socialCampaign.whatsapp && (
          <SocialShareWhatsapp
            url={whatsappUrl}
            handleSocialLinkClick={handleSocialLinkClick}
          />
        )}
        {socialCampaign.twitter && (
          <SocialShareTwitter
            url={twitterUrl}
            handleSocialLinkClick={handleSocialLinkClick}
          />
        )}
        {socialCampaign.copyLink && (
          <SocialShareCopyLink handleOpenCopyModal={handleOpenCopyModal} />
        )}
      </div>
      {socialCampaign.copyLink && (
        <Modal
          title=""
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        >
          <div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-center">
            <ShareIllustration />
          </div>
          <Text size="lg" className="text-center">
            {socialCampaign.copyLinkHeader}
          </Text>
          <Text className="text-center">
            {socialCampaign.copyLinkSubheader}
          </Text>
          <section className={`${css(styles.copyLinkContainer)}`}>
            <div className={`${css(styles.copyLinkFieldContainer)}`}>
              <CopyLink
                url={shareUrl}
                analytics={handleAnalytics}
                messages={{
                  copy: socialCampaign.copyLinkCopy,
                  copied: socialCampaign.copyLinkCopied,
                }}
              />
            </div>
          </section>
        </Modal>
      )}
    </>
  );
}

SocialShare.propTypes = {
  shareUrl: PropTypes.string,
  socialCampaign: PropTypes.object,
};

SocialShare.defaultProps = {
  align: 'center',
  handleAnalytics: null,
};
